import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const getRootDepartmentId = () =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: 'GET'
  });

export const findSafetyAgentPage = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent?` + params,
    method: 'GET'
  });
};

export const findSafetyAgentByRootDepart = (rootDepartId) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent/${rootDepartId}`,
    method: 'GET'
  });

export const addSafetyAgent = (data) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent`,
    method: 'POST',
    data
  });

export const editSafetyAgent = (data) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent`,
    method: 'PUT',
    data
  });

export const delSafetyAgent = (ids) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent/${ids}`,
    method: 'DELETE'
  });